import Button from 'components/base/Button';
import { Col, FloatingLabel, Form, Row, Toast, ToastContainer } from 'react-bootstrap';
import { useAuth } from 'providers/AuthProvider'
import { useState, FormEvent } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import CertificateForm from './components/CertificateForm';
import Dropzone from 'components/base/Dropzone';

const AddCertificate = () => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Feedback'),
            url: '/feedback-dashboard'
        },
        {
            label: t('Certificates'),
            url: '/feedback-dashboard/certificates'
        },
        {
            label: t('Add a certificate'),
            active: true
        }
    ];


    const navigate = useNavigate();
    const auth = useAuth();

    // State to store the form data from all child components
    const [formData, setFormData] = useState<any>({ 'certificateForm': '', 'notes': '', 'files': null });
    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [files, setFiles] = useState<File[]>([]);

    // Function to handle input changes
    const handleNotesInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Function to handle form data update from child components
    const updateFormData = (name: string, data: any) => {
        setFormData({ ...formData, [name]: data });
    };



    const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const form = new FormData();
        form.append('certificateForm', JSON.stringify(formData['certificateForm']));
        form.append('notes', formData['notes']);
        // new file(s)
        files.forEach(file => {
            form.append('files', file);
        });

        try {
            const response = await apiClient.post(
                '/v1/certificates', form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            setToastMessage(response.data['message'])
            setShow(true);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    return (
        <div className="mb-9">
            <div>
                <ToastContainer className="p-3" position='top-center'>
                    <Toast onClose={() => { setShow(false); navigate(-1); }} show={show} delay={3000} autohide>
                        <Toast.Body className=''>{toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>

            <PageBreadcrumb items={breadcrumbItems} />
            <Form onSubmit={handleSumbit}>
                <div className="border-bottom mb-7 mx-n3 px-2 mx-lg-n6 px-lg-6">
                    <Row>
                        <Col xl={12}>
                            <div className="d-sm-flex justify-content-between">
                                <h2 className="mb-4">{t('AddCertificate.create')}</h2>
                                <div className="d-flex mb-3">
                                    <Button variant="phoenix-primary" className="me-2 px-6" onClick={() => navigate(-1)} >
                                        {t('Back')}
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col sm={8} md={8} >
                        <CertificateForm onUpdate={data => updateFormData('certificateForm', data)} className="mb-6" />
                    </Col>
                    <Col>
                        <div className="mb-5">
                            <h4 className="mb-3">{t('AddCertificate.add_document')}</h4>
                            <Dropzone single={true}
                                className="mb-3"
                                onFileListUpdate={files => setFiles(files)}
                                accept={{
                                    'image/*': ['.png', '.gif', '.jpeg', '.jpg'],
                                    'application/pdf': ['.pdf'],
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
                                }}
                            />
                        </div>
                    </Col>
                </Row><Row>
                    <Col>

                        <h4 className="mb-3">{t('AddCertificate.notes')}</h4>
                        <FloatingLabel
                            controlId="certificate-notes"
                            label={t('AddCertificate.create')}
                        >
                            <Form.Control
                                as="textarea"
                                style={{ height: '128px' }}
                                type="text"
                                name='notes' value={formData.notes} onChange={handleNotesInputChange} />
                        </FloatingLabel>
                        <div className="text-end">
                            <Button type="submit" variant="primary" className='mt-2'>{t('AddCertificate.save')}</Button>
                        </div>

                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default AddCertificate;
